var cov_nsm0tq90k = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/EditableArea/styles/index.js",
      hash = "ed092fbccbb98c65b8b474c90a77966dc74811fd",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/EditableArea/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 33
        },
        end: {
          line: 5,
          column: 77
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var editableAreaLess = {};
import genaration from '../../utils/classname';
export var editableAreaClass = (cov_nsm0tq90k.s[0]++, genaration(editableAreaLess, 'editableArea'));